import { createFileRoute } from '@tanstack/react-router';
import { PhoneCaptureStep } from '@/domains/sales/wizard/steps/PhoneCaptureStep';

// Entrada del wizard (ficha 01a — captura de teléfono): crea la sesión y navega a /wizard/s/:id/otp.
export const Route = createFileRoute('/wizard/')({
    component: PhoneCaptureStep,
});
